import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  faEnvelope,
  faPhoneAlt,
  faClock,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../assets/img/logo1.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Helper: active route style
  const isActive = (path) => {
    const isMobile = window.innerWidth <= 768;
    const isScrolled = scrolled;
    //   if (path === "/" && location.pathname === "/") {
    //     return { color: "var(--custom-primary)" }; // Home active on load
    // }
    // When on Home page
    if (location.pathname === "/") {
      // On mobile → green always
      if (isMobile) {
        return { color: "var(--white) !important" };
      }
      // On desktop
      return {
        color: isScrolled ? "var(--peacock-green)" : "var(--white)",
      };
    }

    if (isMobile) {
      if (location.pathname !== "/") {
        return { color: "var(--white) !important" };
      }
    }

    // For other pages
    if (location.pathname === path) {
      return { color: "var(--primary)" };
    }


    return { color: "var(--peacock-green)" };
  };

  // Function to handle dropdown toggle
  const handleDropdownToggle = (index, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // For mobile, close the dropdown if it's already open, otherwise open it
    if (window.innerWidth <= 992) {
      setOpenDropdown(openDropdown === index ? null : index);
    } else {
      // For desktop, use hover (CSS) or keep it simple
      setOpenDropdown(openDropdown === index ? null : index);
    }
  };

  // Function to close all dropdowns and mobile menu
  const closeAllMenus = () => {
    setOpenDropdown(null);
    setIsMobileMenuOpen(false);
  };

  // Function to check if dropdown should be open
  const isDropdownOpen = (index) => {
    return openDropdown === index;
  };

  const navLinks = [
    { name: "Home", path: "/" },
    {
      name: "About Us",
      submenu: [
        { name: "Our Story", path: "/about-us" },
        { name: "Our Approach", path: "/ourapproach" },
        { name: "People We Serve", path: "/people-we-serve" },
      ]
    },
    { name: "Solutions & Services", path: "/solutions-services" },
    { name: "Testimonials", path: "/testimonial" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <header
      className="container-fluid px-0 fixed-top"
      style={{
        transition: "all 0.4s ease",
        backgroundColor: scrolled ? "var(--white)" : "transparent",
        boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
      }}
    >
      {/* ===== Top Bar ===== */}
      <div
        className={`top-bar row gx-0 align-items-center d-none d-lg-flex ${scrolled ? "opacity-0 invisible" : "opacity-100 visible"
          }`}
        style={{
          height: scrolled ? "0" : "40px",
          transition: "all 0.4s ease",
          color: "var(--dark)",
          backgroundColor: "var(--light-bg)",
        }}
      >
        <div className="col-lg-6 px-5 text-start">
          <small>
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            Gurugram , Haryana
          </small>
          <small className="ms-4">
            <FontAwesomeIcon
              icon={faClock}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            10.00 A.M. - 6.00 P.M.
          </small>
        </div>
        <div className="col-lg-6 px-5 text-end">
          <small>
            <FontAwesomeIcon
              icon={faEnvelope}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            connect@sagfinancials.com
          </small>
          <small className="ms-4">
            <FontAwesomeIcon
              icon={faPhoneAlt}
              className="me-2"
              style={{ color: "var(--primary)" }}
            />
            +91 7011468336
          </small>
        </div>
      </div>

      {/* ===== Navbar ===== */}
      <nav className="navbar navbar-expand-lg py-1 px-lg-5">
        {/* Logo */}
        <Link
          to="/"
          className="navbar-brand d-flex align-items-center ms-3"
          onClick={closeAllMenus}
        >
          <img
            src={logo}
            alt="SAG Financials Logo"
            className="me-2 mobilelogo  rounded"
            style={{
              height: "70px",
              width: "auto",
              objectFit: "contain",
              background: "white"

            }}
          />
          <h1
            className="m-0 fw-bold d-none"
            style={{
              color: "var(--primary)",
              fontSize: "1.8rem",
              transition: "color 0.3s ease",
            }}
          >
            SAG Financials
          </h1>
        </Link>

        {/* Toggler */}
        <button
          className="navbar-toggler me-4 d-lg-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation"
          style={{
            border: "1.5px solid black",
            padding: "6px 7px",
            borderRadius: "8px",
            
            display: "flex",
            alignItems: "center",
           
          }}
        >
          {/* 3 Vertical Dots */}
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>&#8942;</div>

          {/* 3 Lines */}
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <span style={{ width: "22px", height: "3px", background: "black", borderRadius: "3px" }}></span>
            <span style={{ width: "22px", height: "3px", background: "black", borderRadius: "3px" }}></span>
            <span style={{ width: "22px", height: "3px", background: "black", borderRadius: "3px" }}></span>
          </div>
        </button>



        {/* Navigation Links */}
        <div
          className={`collapse navbar-collapse ${isMobileMenuOpen ? 'show' : ''}`}
          id="navbarCollapse"
        >
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            {navLinks.map((link, i) => (
              <div
                key={i}
                className="nav-item dropdown"
                onMouseEnter={() => {
                  if (window.innerWidth > 992) {
                    setOpenDropdown(i);
                  }
                }}
                onMouseLeave={() => {
                  if (window.innerWidth > 992) {
                    setOpenDropdown(null);
                  }
                }}
              >
                {link.submenu ? (
                  <>
                    {/* Parent dropdown link */}
                    <span
                      className="nav-link dropdown-toggle"
                      onClick={(e) => handleDropdownToggle(i, e)}
                      style={{
                        cursor: "pointer",
                        fontWeight: 700,
                        transition: "color 0.3s ease",
                        ...isActive(link.path)
                      }}
                    >
                      {link.name}
                    </span>

                    {/* Dropdown menu */}
                    <div
                      className={`dropdown-menu m-0 ${isDropdownOpen(i) ? 'show' : ''}`}
                      style={{
                        display: isDropdownOpen(i) ? 'block' : 'none',
                      }}
                    >
                      {link.submenu.map((sub, j) => (
                        <Link
                          key={j}
                          to={sub.path}
                          className="dropdown-item"
                          style={{ fontWeight: 600 }}
                          onClick={closeAllMenus}
                        >
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : (
                  // Regular link (no dropdown)
                  <Link
                    to={link.path}
                    className="nav-link"
                    style={{
                      fontWeight: 700,
                      transition: "color 0.3s ease",
                      ...isActive(link.path)
                    }}
                    onClick={closeAllMenus}
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Social Icons */}
          <div className="d-none d-lg-flex ms-3">
            <a
              href="https://www.facebook.com/share/1D2BYZrbo8/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn ms-2"
              style={{
                color: "var(--primary)",
                backgroundColor: "var(--light-bg)",
                borderRadius: "50%",
                padding: "8px 10px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "var(--secondary)";
                e.currentTarget.style.color = "var(--white)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "var(--light-bg)";
                e.currentTarget.style.color = "var(--primary)";
              }}
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a
              href="https://www.instagram.com/finance.with.shepra/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn ms-2"
              style={{
                color: "var(--primary)",
                backgroundColor: "var(--light-bg)",
                borderRadius: "50%",
                padding: "8px 10px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "var(--secondary)";
                e.currentTarget.style.color = "var(--white)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "var(--light-bg)";
                e.currentTarget.style.color = "var(--primary)";
              }}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://www.linkedin.com/company/sag-financials/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn ms-2"
              style={{
                color: "var(--primary)",
                backgroundColor: "var(--light-bg)",
                borderRadius: "50%",
                padding: "8px 10px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "var(--secondary)";
                e.currentTarget.style.color = "var(--white)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "var(--light-bg)";
                e.currentTarget.style.color = "var(--primary)";
              }}
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;